import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <div dir="rtl" className="min-h-screen bg-gray-900 text-gray-100">
      <App />
    </div>
  </React.StrictMode>
);
